// this class defines constants used across multiple directory components and methods 
export class CphConstants {
    static readonly StaffSignature = "AAP Coding and Payment Advocacy Team";
}